import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faCirclePause } from '@fortawesome/free-solid-svg-icons';
import { handleStepBackward, handleStepForward } from '../utils/videoPlayerUtils';
import { setBooleanState } from '../../../features/videoPlayer/videoPlayer.slice';
import backwardStep5Second from '../../../assets/backwardStep5.svg';
import forwardStep5Second from '../../../assets/forwardStep5.svg';

const MidPlayerButtons = ({videoRef, togglePlayPause}) => {

    const hovering = useSelector((state) => state.videoPlayer.hovering);
    const isBuffering = useSelector((state) => state.videoPlayer.isBuffering);
    const isPlaying = useSelector((state) => state.videoPlayer.isPlaying);

    return (
        <div>
            {hovering && !isBuffering && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2,
                }}
            >
                <button
                style={{
                    color: '#fff',
                    background: 'none',
                    border: 'none',
                    fontSize: '2.5rem',
                    marginRight: '20px',
                }}
                onClick={() => handleStepBackward(videoRef)}
                >
                {/* <FontAwesomeIcon icon={faBackwardStep} /> */}
                <img className='step-button' src={backwardStep5Second} alt="Backward 5 seconds"/>
                </button>
                <button
                onClick={() => togglePlayPause(videoRef)}
                className='play-button mt-2 mt-md-0'
                >
                {isPlaying ? 
                    <FontAwesomeIcon icon={faCirclePause} /> : 
                    <FontAwesomeIcon icon={faCirclePlay} />
                }
                </button>
                <button
                style={{
                    color: '#fff',
                    background: 'none',
                    border: 'none',
                    fontSize: '2.5rem',
                    marginLeft: '20px',
                }}
                onClick={() => handleStepForward(videoRef)}
                >
                {/* <FontAwesomeIcon icon={faForwardStep} /> */}
                <img className='step-button' src={forwardStep5Second} alt="Forward 5 seconds" />
                </button>
            </div>
            )}
        </div>
    )
}

export default MidPlayerButtons